<div class="header-bar"><h1>Manage VAT Rates</h1></div>
<div class="content-container">
  <div class="">
    <div class="ui-grid-row">
      <div class="ui-g-12">
        <form (ngSubmit)="search()" style="width: 100%">
          <div class="ui-g filterPanel">
            <div class="ui-g-12 ui-md-4 ui-lg-2">
              <span class="md-inputfield filterItem">
                <input
                  name="vatRate"
                  [(ngModel)]="filterVal.filters.vatRate.value"
                  style="width: 160px"
                  pInputText
                  maxlength="5"
                  (keydown)="inputHelper.allowNumberInputKey($event)"
                />
                <label>VAT Rate</label>
              </span>
            </div>

            <div class="ui-g-12 ui-md-4 ui-lg-2">
              <span class="md-inputfield filterItem">
                <p-calendar
                  name="dateToApplyRate"
                  [(ngModel)]="filterVal.filters.dateToApplyRate.value"
                  dataType="string"
                  dateFormat="yy-mm-dd"
                ></p-calendar>
                <label>Date To Apply</label>
              </span>
            </div>

            <div class="ui-g-12 ui-md-4 ui-lg-2">
              <button
                pButton
                type="button"
                class="ui-button-tertiary"
                label="Clear"
                (click)="clearFilter(dataTable)"
              ></button>
              <button pButton type="submit" label="Search"></button>
            </div>
          </div>
        </form>

        <p-table
          #dataTable
          selectionMode="single"
          [value]="page.items"
          [lazy]="true"
          [rows]="10"
          [responsive]="true"
          [paginator]="true"
          rowHover="true"
          resizableColumns="true"
          [totalRecords]="page.total"
          (onLazyLoad)="onGridLazyLoad($event)"
          [rowsPerPageOptions]="[5, 10, 20]"
          [pageLinks]="3"
          [(selection)]="selectedItem"
          [hidden]="!isLoaded"
        >
          <ng-template pTemplate="header">
            <tr>
              <th pSortableColumn="vatRate">VAT Rate</th>
              <th pSortableColumn="dateToApplyRate">Date to Apply</th>
            </tr>
          </ng-template>

          <ng-template pTemplate="body" let-item>
            <tr (dblclick)="onRowDblclick(item)" [pSelectableRow]="item">
              <td>{{ item.vatRate }}</td>
              <td>{{ item.dateToApplyRate | date : 'dd/MM/y' }}</td>
            </tr>
          </ng-template>
        </p-table>

        <!--- DATATABLE DEPRECATED --
                  <p-dataTabl #dataTable selectionMode="single" [value]="page.items" [lazy]="true" [rows]="10"
                               [responsive]="true" [paginator]="true" rowHover="true" resizableColumns="true"
                               [totalRecords]="page.total" (onLazyLoad)="onGridLazyLoad($event)"
                               (onRowDblclick)="onRowDblclick($event)" [rowsPerPageOptions]="[5,10,20]" [pageLinks]="3"
                               [(selection)]="selectedItem"
                               [hidden]="!isLoaded">
                      <p-column field="vatRate" header="VAT Rate" [sortable]="tru" [editable]="false"></p-column>
                      <p-column field="dateToApplyRate" header="Date to Apply" [sortabl]="true" [editable]="false">
                          <ng-template pTemplate="body" let-item="rowData">
                                  {{item.dateToApplyRate | date:'dd/MM/y'}}
                          </ng-template>
                      </p-column>
                  </p-dataTable>
                  -->
      </div>
    </div>
    <div class="footerPanel ui-grid-row">
      <div class="ui-g-12">
        <button
          type="button"
          class="btn-to-right ui-button-primary ui-button"
          pButton
          icon="fa ui-icon-add"
          (click)="showDialogToAdd()"
          label="Add"
        ></button>
        <button
          type="button"
          class="btn-to-right ui-button ui-button-tertiary"
          pButton
          (click)="onEdit(selectedItem)"
          label="Edit"
          icon="fa ui-icon-mode-edit"
          [disabled]="!selectedItem"
        ></button>
        <button
          type="button"
          class="ui-button-danger btn-to-right ui-button"
          pButton
          icon="fa ui-icon-trash"
          (click)="onDelete()"
          label="Delete"
          [disabled]="!selectedItem"
        ></button>
      </div>
    </div>

    <p-dialog
      header="VAT Rate"
      [(visible)]="displayDialog"
      [responsive]="true"
      [modal]="true"
      [style]="{ width: '400px' }"
    >
      <form [formGroup]="newVATRateForm" (ngSubmit)="save(newVATRateForm.value)" autocomplete="off">
        <div class="ui-grid ui-grid-responsive ui-fluid" *ngIf="editingItem">
          <div class="ui-g-12">
            <div class="ui-g-4"><label for="vatRate">VAT Rate</label></div>
            <div class="ui-g-8">
              <input
                formControlName="vatRate"
                id="vatRate"
                pInputText
                maxlength="5"
                (keydown)="inputHelper.allowNumberInputKey($event)"
              />
            </div>
          </div>
          <div class="ui-g-12">
            <div class="ui-g-4"><label for="dateToApplyRate">Date To Apply</label></div>
            <div class="ui-g-8">
              <p-calendar
                id="dateToApplyRate"
                formControlName="dateToApplyRate"
                [minDate]="minDateValue"
                dataType="string"
                dateFormat="yy-mm-dd"
                [showIcon]="true"
                appendTo="body"
                [disabled]="editingItem.id != 0 && isAlreadyStarted(editingItem)"
              ></p-calendar>
              <!--<div *ngIf="inputErrorToShow(dateToApplyRate)" class="ui-message ui-messages-error ui-corner-all">
                                  {{inputErrorToShow(dateToApplyRate)}}
                              </div>-->
            </div>
          </div>
        </div>

        <div style="float: right">
          <button
            type="button"
            pButton
            icon="fa ui-icon-close"
            label="Cancel"
            class="ui-button-tertiary"
            (click)="close()"
          ></button>
          <button
            type="submit"
            class="green-btn"
            pButton
            icon="fa ui-icon-check"
            label="Save"
            [disabled]="newVATRateForm.invalid"
          ></button>
        </div>
      </form>
    </p-dialog>
  </div>
</div>
<ng-template #loading>Loading...</ng-template>
